import { render, staticRenderFns } from "./LayoutsFilterControls.vue?vue&type=template&id=576469bd&scoped=true"
import script from "./LayoutsFilterControls.vue?vue&type=script&lang=js"
export * from "./LayoutsFilterControls.vue?vue&type=script&lang=js"
import style0 from "./LayoutsFilterControls.vue?vue&type=style&index=0&id=576469bd&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576469bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('576469bd')) {
      api.createRecord('576469bd', component.options)
    } else {
      api.reload('576469bd', component.options)
    }
    module.hot.accept("./LayoutsFilterControls.vue?vue&type=template&id=576469bd&scoped=true", function () {
      api.rerender('576469bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/LayoutsFilterControls.vue"
export default component.exports